import { render, staticRenderFns } from "./SuperAdminPanel.vue?vue&type=template&id=09b68f34&scoped=true&"
import script from "./SuperAdminPanel.vue?vue&type=script&lang=js&"
export * from "./SuperAdminPanel.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminPanel.vue?vue&type=style&index=0&id=09b68f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b68f34",
  null
  
)

export default component.exports